export const dropdown = `<svg width="17" height="10" viewBox="0 0 17 10" fill="none" xmlns="http://www.w3.org/2000/svg">
<path d="M8.01333 9.29388L16.0267 1.77116L14.1427 0L8.01333 5.75782L1.88533 0L0 1.7699L8.01333 9.29388Z" fill="#00ABC7"/>
</svg>
`;
